/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Adr_Enable_Preview_HelpInputs */

const en_options_adr_enable_preview_help = /** @type {(inputs: Options_Adr_Enable_Preview_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update the static text preview with an animated preview to help when recording.`)
};

const fr_options_adr_enable_preview_help = /** @type {(inputs: Options_Adr_Enable_Preview_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplacer l'aperçu statique par un aperçu animé pour aider lors de l'enregistrement.`)
};

const de_options_adr_enable_preview_help = /** @type {(inputs: Options_Adr_Enable_Preview_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ersetzen Sie die statische Textvorschau durch eine animierte Vorschau, um die Aufnahme zu erleichtern.`)
};

const it_options_adr_enable_preview_help = /** @type {(inputs: Options_Adr_Enable_Preview_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna l'anteprima del testo statico con un'anteprima animata per facilitare la registrazione.`)
};

const ru_options_adr_enable_preview_help = /** @type {(inputs: Options_Adr_Enable_Preview_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Замените статический текстовый предварительный просмотр на анимированный, чтобы упростить запись.`)
};

const es_options_adr_enable_preview_help = /** @type {(inputs: Options_Adr_Enable_Preview_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualice la vista previa de texto estático con una vista previa animada para ayudar durante la grabación.`)
};

const zh_cn2_options_adr_enable_preview_help = /** @type {(inputs: Options_Adr_Enable_Preview_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将静态文本预览更新为动画预览，以便在录制时提供帮助。`)
};

const ja_options_adr_enable_preview_help = /** @type {(inputs: Options_Adr_Enable_Preview_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`録画時に役立つように、静的テキスト プレビューをアニメーション プレビューに更新します。`)
};

const hi_options_adr_enable_preview_help = /** @type {(inputs: Options_Adr_Enable_Preview_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिकॉर्डिंग के दौरान सहायता के लिए स्टैटिक टेक्स्ट प्रीव्यू को एनिमेटेड प्रीव्यू से अपडेट करें।`)
};

const pt_pt2_options_adr_enable_preview_help = /** @type {(inputs: Options_Adr_Enable_Preview_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualize a pré-visualização de texto estático com uma pré-visualização animada para auxiliar durante a gravação.`)
};

/**
* | output |
* | --- |
* | "Update the static text preview with an animated preview to help when recording." |
*
* @param {Options_Adr_Enable_Preview_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_adr_enable_preview_help = /** @type {((inputs?: Options_Adr_Enable_Preview_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Adr_Enable_Preview_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_adr_enable_preview_help(inputs)
	if (locale === "de") return de_options_adr_enable_preview_help(inputs)
	if (locale === "it") return it_options_adr_enable_preview_help(inputs)
	if (locale === "ru") return ru_options_adr_enable_preview_help(inputs)
	if (locale === "es") return es_options_adr_enable_preview_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_adr_enable_preview_help(inputs)
	if (locale === "ja") return ja_options_adr_enable_preview_help(inputs)
	if (locale === "hi") return hi_options_adr_enable_preview_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_adr_enable_preview_help(inputs)
	return en_options_adr_enable_preview_help(inputs)
});